/* custom-filter-variants.js – Filtert Option2 abhängig von Option1 (sicheres Scoping) */
(function () {
  function log(){ try{ console.log.apply(console, arguments);}catch(e){} }

  function init(root) {
    const containers = root.querySelectorAll('section.product__info-container');
    log('[VariantFilter] containers:', containers.length);
    if (!containers.length) return;

    containers.forEach(container => {
      const jsonEl = container.querySelector('script.variant-json');
      if (!jsonEl) { log('[VariantFilter] keine variant-json im Container'); return; }

      let variants = [];
      try { variants = JSON.parse(jsonEl.textContent || '[]'); }
      catch (e) { log('[VariantFilter] JSON parse error', e); return; }
      if (!variants.length) { log('[VariantFilter] keine Varianten'); return; }

      // sichtbaren Picker finden
     let picker =
  Array.from(container.querySelectorAll('variant-selects, variant-radios'))
    .find(p => p.offsetParent !== null && getComputedStyle(p).display !== 'none') ||
  container.querySelector('variant-radios') ||
  container.querySelector('variant-selects');

      if (!picker) { log('[VariantFilter] kein Picker gefunden'); return; }

      let opt1 = null, opt2 = null;

      // Dropdowns?
      const selects = Array.from(picker.querySelectorAll('select'));
      if (selects.length >= 2) {
        opt1 = { type: 'select', el: selects[0] };
        opt2 = { type: 'select', el: selects[1] };
      }

      // Buttons (Radios)?
      if (!opt1 || !opt2) {
        const groups = Array.from(picker.querySelectorAll('fieldset'));
        if (groups.length >= 2) {
          opt1 = { type: 'radios', el: groups[0] };
          opt2 = { type: 'radios', el: groups[1] };
        }
      }

      if (!opt1 || !opt2) { log('[VariantFilter] zu wenige Controls im Picker'); return; }

      // Ermittelt, welche Option "option1"/"option2" ist – robust gegen vertauschte Reihenfolge
const vKey1 = (opt1.el.dataset.index || opt1.el.getAttribute('data-index') || 'option1').toLowerCase();
const vKey2 = (opt2.el.dataset.index || opt2.el.getAttribute('data-index') || 'option2').toLowerCase();

      function getOpt1Val() {
        if (opt1.type === 'select') return (opt1.el && opt1.el.value) ? String(opt1.el.value).trim() : '';
        const checked = opt1.el.querySelector('input[type="radio"]:checked');
        return checked ? String(checked.value).trim() : '';
      }

      function allowedFor(needle) {
        const s = new Set();
        for (let i=0; i<variants.length; i++) {
          const v = variants[i];
          if (v[vKey1] === needle /* && v.available */) s.add(v[vKey2]);
        }
        return s;
      }
function refreshRefs() {
  // wenn Dawn den Picker neu gerendert hat → Refs neu holen
  if (!picker || !container.contains(picker)) {
    picker =
      Array.from(container.querySelectorAll('variant-selects, variant-radios'))
        .find(p => p.offsetParent !== null && getComputedStyle(p).display !== 'none') ||
      container.querySelector('variant-radios') ||
      container.querySelector('variant-selects');
  }
  if (!picker) return false;

  let s = Array.from(picker.querySelectorAll('select'));
  let g = Array.from(picker.querySelectorAll('fieldset'));
  if (s.length >= 2) {
    opt1 = { type: 'select', el: s[0] };
    opt2 = { type: 'select', el: s[1] };
  } else if (g.length >= 2) {
    opt1 = { type: 'radios', el: g[0] };
    opt2 = { type: 'radios', el: g[1] };
  }
  return !!(opt1 && opt2);
}
      function filter() {
        function filter() {
  if (!refreshRefs()) return;
  // … (Rest bleibt gleich)
}
        const needle = getOpt1Val();
        if (!needle) return;
        const allowed = allowedFor(needle);

        if (opt2.type === 'select') {
          let changed = false;
          Array.prototype.forEach.call(opt2.el.options, function(o){
            const ok = allowed.has(String(o.value).trim());
            o.disabled = !ok;
            if (!ok && o.selected) { o.selected = false; changed = true; }
          });
          const firstOk = Array.prototype.find.call(opt2.el.options, o => !o.disabled);
          if (firstOk && !firstOk.selected) { firstOk.selected = true; changed = true; }
          if (changed) opt2.el.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
  let anyChecked = false;
  const scope = opt2.el; // Fieldset von Option 2 (Größe)
  opt2.el.querySelectorAll('input[type="radio"]').forEach(input => {
    const val = String(input.value).trim();
    const ok  = allowed.has(val);

    // Label finden: zuerst per for=ID, sonst "input + label"
    let label = scope.querySelector(`label[for="${input.id}"]`) ||
                (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null) ||
                input.closest('label');

    if (label && scope.contains(label)) {
      label.classList.toggle('vf-hidden', !ok);
    }
    input.disabled = !ok;

    if (ok && input.checked) anyChecked = true;
    if (!ok && input.checked) input.checked = false;
  });

  if (!anyChecked) {
    const first = opt2.el.querySelector('input[type="radio"]:not(:disabled)');
    if (first) {
      first.checked = true;
      first.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}
      }

      // Events
      if (opt1.type === 'select') {
        opt1.el.addEventListener('change', filter);
      } else {
        opt1.el.querySelectorAll('input[type="radio"]').forEach(i => i.addEventListener('change', filter));
        // zusätzlich zu deinen opt1-change Listeners:
container.addEventListener('change', () => setTimeout(filter, 0));          // nach jeder Änderung erneut filtern
document.addEventListener('variant:change', () => setTimeout(filter, 0));   // Dawn-Event (falls vorhanden)
document.addEventListener('theme:variant:change', () => setTimeout(filter,0)); // ältere/andere Themes

// wenn Dawn DOM ersetzt → erneut filtern
const mo = new MutationObserver(() => { refreshRefs(); setTimeout(filter, 0); });
mo.observe(container, { childList: true, subtree: true });
      }

      // initial
      setTimeout(filter, 0);
      log('[VariantFilter] aktiv:', picker.tagName.toLowerCase(), opt1.type + '/' + opt2.type);
    });
  }

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', e => init(e.target));
  }

  boot();
})();